
import "firebase/auth";
import firebase from 'firebase/app';



export const auth =  firebase.initializeApp({
  apiKey: "AIzaSyBC5TCWRvhyrTV2P8m9j8sPLbsP9rLioqQ",
  authDomain: "my-chat-a4e58.firebaseapp.com",
  projectId: "my-chat-a4e58",
  storageBucket: "my-chat-a4e58.appspot.com",
  messagingSenderId: "598481205494",
  appId: "1:598481205494:web:a3f763fed181c553f694d7"
}).auth();


//  auth problem like redirecnt 


